import { useLocation } from "react-router-dom";
import { Box, Grid, useMediaQuery } from "@mui/material";
import Header from "../../components/Header/Header";
import Signup from "./signup/Signup";
import Footer from "../../components/Footer/Footer";
import theme from "../../theme";
import { routes } from "../../utils/constants/routes";
import SignIn from "./signin/Signin";
import ResetPassword from "./ResetPassword/ResetPassword";

const AuthLayout = () => {

  const isMobile = useMediaQuery("(max-width:1050px)"); 

  const location = useLocation();

  console.log(location, "location")

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "2rem"
      }}
    >
      <Grid container 
        sx={{ 
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          minHeight: !isMobile ? "100vh" : "0",
          width: "90vw",
          maxWidth: "1920px",
          margin: "0 auto",
          gap: "2rem"
        }}
      >
        <Header />
        {location?.pathname === routes.authSignup ? (
          <Signup />
        ) : null}
        {location?.pathname === routes.authSignin ? (
          <SignIn />
        ) : null}
        {location?.pathname === routes.resetPassword ? (
          <ResetPassword />
        ) : null}
      </Grid>
      <Footer />
    </Box>
  )
};

export default AuthLayout;